export default "<app-actions-list></app-actions-list>"